import {isValidImageCoordinates} from '../../../../../Map/imageCoordinates'

const collectCoordinatePairs = (value, pairs = []) => {
  if (!Array.isArray(value)) {
    return pairs
  }

  if (
    value.length >= 2 &&
    typeof value[0] === 'number' &&
    typeof value[1] === 'number'
  ) {
    pairs.push(value)
    return pairs
  }

  value.forEach((item) => collectCoordinatePairs(item, pairs))
  return pairs
}

const getBboxCoordinatesFromPolygon = (polygon) => {
  const coordinates = collectCoordinatePairs(polygon?.coordinates || polygon)

  if (coordinates.length < 1) {
    return null
  }

  const lngValues = coordinates.map((coordinate) => coordinate[0])
  const latValues = coordinates.map((coordinate) => coordinate[1])
  const minLng = Math.min(...lngValues)
  const maxLng = Math.max(...lngValues)
  const minLat = Math.min(...latValues)
  const maxLat = Math.max(...latValues)

  if (![minLng, maxLng, minLat, maxLat].every(Number.isFinite)) {
    return null
  }

  const bbox = [
    [minLng, maxLat],
    [maxLng, maxLat],
    [maxLng, minLat],
    [minLng, minLat],
  ]
  return isValidImageCoordinates(bbox) ? bbox : null
}

export const getLayerBbox = (headers, polygon) => {
  if (headers?.['x-bbox']) {
    try {
      const bbox = JSON.parse(headers['x-bbox'])
      if (isValidImageCoordinates(bbox)) {
        return bbox
      }
    } catch (error) {
      // Fallback below.
    }
  }

  return getBboxCoordinatesFromPolygon(polygon)
}

export const recoverCachedImageLayer = (payload, polygon) => {
  if (!payload) {
    return null
  }
  const bbox = isValidImageCoordinates(payload.bbox)
    ? payload.bbox
    : getBboxCoordinatesFromPolygon(polygon)
  return bbox ? {...payload, bbox} : null
}

export const parseIndexRangeHeader = (headers) => {
  const serializedIntervals = headers?.['x-index-range'] ?? headers?.['x-intervals']

  if (!serializedIntervals) {
    return null
  }

  try {
    const intervals = JSON.parse(serializedIntervals)
    return Array.isArray(intervals) && intervals.every((item) => item && typeof item === 'object' && !Array.isArray(item))
      ? intervals : null
  } catch (error) {
    return null
  }
}

// Single-raster headers use fractions; legend UI uses percentages. Preserve
// provider colors, open interval bounds and measured AOI metadata unchanged.
export const parseSingleIndexLegendHeaders = (headers) => {
  const intervals = parseIndexRangeHeader(headers)
  if (!intervals?.length) return null
  return {
    ...headers,
    'x-index-range': JSON.stringify(intervals.map((interval) => ({
      ...interval,
      percentage: interval.percentage == null || interval.percentage === ''
        ? null : Number.isFinite(Number(interval.percentage)) ? Number(interval.percentage) * 100 : null,
    }))),
  }
}
